import React, { useEffect, useState } from "react";
import {
    createHeroSection,
    getAllHeroSections,
    updateHeroSection,
} from "../../services/section/first_section";

const HeroSectionForm = () => {
    const [form, setForm] = useState({
        section_id: "",
        type: "",
        title: "",
        subtitle: "",
        description: "",
        button_label: "",
        button_action: "",
    });

    const [sections, setSections] = useState([]);
    const [editId, setEditId] = useState(null);
    const [message, setMessage] = useState("");

    const token = localStorage.getItem("accessToken");

    const fetchSections = async () => {
        try {
            const data = await getAllHeroSections();
            setSections(data);
        } catch (error) {
            console.error("Failed to fetch hero sections", error);
        }
    };

    useEffect(() => {
        fetchSections();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = editId
                ? await updateHeroSection(editId, form, token)
                : await createHeroSection(form, token);

            setMessage(data.message || "Success");
            setForm({
                section_id: "",
                type: "",
                title: "",
                subtitle: "",
                description: "",
                button_label: "",
                button_action: "",
            });
            setEditId(null);
            fetchSections();
        } catch (error) {
            console.error("Submission error", error);
            setMessage("Failed to save section");
        }
    };

    const handleEdit = (section) => {
        setForm(section);
        setEditId(section.id);
    };

    return (
        <div className="p-4 max-w-3xl mx-auto bg-white text-gray-900 dark:bg-gray-900 dark:text-white min-h-screen">
            <h2 className="text-xl font-bold mb-4">Hero Section Manager</h2>

            {message && <div className="mb-4 text-green-600 dark:text-green-400">{message}</div>}

            <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
                <input
                    type="text"
                    name="title"
                    placeholder="Title"
                    className="p-2 border rounded bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                    value={form.title}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="subtitle"
                    placeholder="Subtitle"
                    className="p-2 border rounded bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                    value={form.subtitle}
                    onChange={handleChange}
                    required
                />
                <textarea
                    name="description"
                    placeholder="Description"
                    className="p-2 border rounded bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                    value={form.description}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="button_label"
                    placeholder="Button Label"
                    className="p-2 border rounded bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                    value={form.button_label}
                    onChange={handleChange}
                />
                <input
                    type="text"
                    name="button_action"
                    placeholder="Button Action (e.g., /about)"
                    className="p-2 border rounded bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                    value={form.button_action}
                    onChange={handleChange}
                />
                <button
                    type="submit"
                    className="py-2 px-4 rounded bg-blue-600 hover:bg-blue-700 text-white dark:bg-blue-500 dark:hover:bg-blue-600 transition"
                >
                    {editId ? "Update Section" : "Create Section"}
                </button>
            </form>

            <div className="mt-10">
                <h3 className="text-lg font-semibold mb-2">Existing Sections</h3>
                {sections.map((section) => (
                    <div
                        key={section.id}
                        className="p-4 border rounded mb-4 bg-white dark:bg-gray-800 dark:border-gray-700"
                    >
                        <h4 className="font-bold dark:text-white">{section.title}</h4>
                        <p className="text-sm dark:text-gray-300">{section.subtitle}</p>
                        <p className="dark:text-gray-300">{section.description}</p>
                        <p>
                            <strong>Button:</strong> {section.button_label} → {section.button_action}
                        </p>
                        <button
                            onClick={() => handleEdit(section)}
                            className="mt-2 text-blue-600 dark:text-blue-400 underline"
                        >
                            Edit
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HeroSectionForm;
